import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const SectionWrapper = styled.section`
  padding: 60px 0;
  background-color: ${({ theme }) => theme.color.neutral.lighter3};
  text-align: center;

  ${screen.lg} {
    padding: 100px 0;
  }
`;

export const LogoWrapper = styled.div`
  width: 243px;
  height: 28px;
  margin: 0 auto 24px;

  svg {
    max-width: 100%;
    height: auto;
  }

  ${screen.lg} {
    width: 418px;
    height: 48px;
    margin: 0 auto 40px;
  }
`;

export const TitleWrapper = styled.div``;

export const Title = styled.h2`
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  color: rgb(${getToken('color-primary-100')});
  text-wrap: balance;
  text-align: center;

  font-size: 26px;
  line-height: 39px;
  margin: 0;

  ${screen.lg} {
    font-size: 38px;
    line-height: 43.7px;
  }
`;

export const Description = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: ${getToken('font-weight-regular')};
  color: rgb(${getToken('color-primary-100')});
  font-size: 16px;
  line-height: 24px;
  margin: 24px auto;
  text-align: center;

  ${screen.md} {
    max-width: 625px;
  }

  ${screen.lg} {
    margin: 40px auto;

    font-weight: ${getToken('font-weight-medium')};
    font-size: 20px;
    line-height: 30px;

    max-width: 910px;
  }
`;

export const MediaWrapper = styled.div`
  margin: auto;
  max-width: 315px;
  height: 177px;

  ${screen.md} {
    max-width: 690px;
    height: 387px;
  }

  ${screen.lg} {
    max-width: 826px;
    height: 464px;
  }

  ${screen.xxlg} {
    max-width: 1086px;
    height: 610px;
  }
`;

export const ContenCopy = styled.div`
  font-family: ${getToken('font-family-default')};
  font-weight: ${getToken('font-weight-regular')};
  color: rgb(${getToken('color-primary-100')});
  font-size: 14px;
  line-height: 21px;
  margin: 24px auto;
  text-wrap: balance;
  text-align: center;

  ${screen.lg} {
    margin: 40px auto;
    max-width: 850px;
  }

  ${screen.xxlg} {
    font-size: 20px;
    line-height: 36px;

    max-width: 1000px;
  }
`;

export const CTAWrapper = styled.div`
  a {
    border-color: transparent;
  }
`;
